<div class="itsl-participants__modal">
    <Modal
        id={dialogId}
        bind:enabled
        cancelText={lang.main('Cancel')}
        confirmText={lang.main('Assign')}
        scrollBody={true}
        {titleText}
        on:confirm={handleConfirm}
        on:cancel
    >
        <slot name="banner" slot="banner">
            <Banner
                closable={false}
                text={lang.main('An_error_occurred_please_try_again')}
                type="warning"
                visible={somethingWentWrongBannerVisible}
            />
            <slot name="customBanner"></slot>
        </slot>

        <div slot="body">
            {#if groupsEnabled}
                <Tabs
                    tabs={participantsTabs}
                    bind:selectedIndex={selectedTabIndex} >

                    <TabPanel
                        id="participantsSection"
                        labelledBy="participantsTab"
                        preloadContent={false}
                        type="container"
                    >
                        <Participants
                            bind:this={participantsComponent}
                            {selectedParticipantIds}
                            {pageSizesList}
                            {getParticipantsFn}
                            emptyStateLinkUrl={addParticipantsLinkUrl}
                            on:error={handleError}
                        />
                    </TabPanel>

                    <TabPanel
                        id="groupsSection"
                        labelledBy="groupsTab"
                        preloadContent={false}
                        type="container"
                    >
                        <Groups
                            bind:this={groupsComponent}
                            {selectedGroupIds}
                            bind:selectedTitle={selectedGroupName}
                            {selectedTitles}
                            {pageSizesList}
                            {getGroupsFn}
                            emptyStateLinkUrl={addGroupLinkUrl}
                            on:error={handleError}
                        />
                    </TabPanel>
                </Tabs>
            {:else}
                <Participants
                    bind:this={participantsComponent}
                    {selectedParticipantIds}
                    {pageSizesList}
                    {getParticipantsFn}
                    emptyStateLinkUrl={addParticipantsLinkUrl}
                    on:error={handleError}
                />
            {/if}
        </div>
    </Modal>
</div>

<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte';

    import Banner from "@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte";
    import Modal from "@itslearning/prometheus/assets/modals/Modal/v2/Modal.svelte";
    import TabPanel from "@itslearning/prometheus/assets/Navigation/Tabs/v1/TabPanel.svelte";
    import Tabs from "@itslearning/prometheus/assets/Navigation/Tabs/v1/Tabs.svelte";

    import Groups from './groups/Groups.svelte';
    import Participants from './participants/Participants.svelte';

    import { lang } from "@its-ui/mono/lang/provider";

    import type {
        GetParticipantGroupsFn,
        GetParticipantsFn
    } from '../courseParticipantsDataProvider';

    const dispatch = createEventDispatcher();

    export let dialogId;
    export let enabled = false;
    export let titleText;

    export let pageSizesList: number[];
    export let selectedParticipantIds: number[];
    export let selectedGroupIds: number[];
    export let selectedGroupName: string;
    export let groupsEnabled: boolean;
    export let getParticipantsFn: GetParticipantsFn;
    export let getGroupsFn: GetParticipantGroupsFn;
    export let addParticipantsLinkUrl: string;
    export let addGroupLinkUrl: string;

    const selectedTitles = new Map<number, string>();

    let selectedTabIndex = 0;

    let participantsComponent: Participants;

    let groupsComponent: Groups;

    let somethingWentWrongBannerVisible = false;

    let prevEnabled = false;
    $: {
        if (prevEnabled !== enabled) {
            prevEnabled = enabled;
            if (!enabled) {
                somethingWentWrongBannerVisible = false;
            }
        }
    }

    onMount(() => {
        if (selectedTitles && selectedGroupIds?.length === 1 && selectedGroupName) {
            selectedTitles.set(selectedGroupIds[0], selectedGroupName);
        }
    });

    const participantsTabs = [
        {
            id: "participantsTab",
            target: "#participantsSection",
            title: lang.main('Persons')
        },
        {
            id: "groupsTab",
            target: "#groupsSection",
            title: lang.main('Groups')
        }
    ];

    function handleConfirm(): void {
        const participantIds = participantsComponent.getSelectedValues();
        const {
            selectedIds: groupsIds,
            selectedTitle: selectedTitle
        } = groupsComponent.getSelectedValues()

        dispatch('dialogConfirmed', {
            participantIds,
            groupsIds,
            groupName: selectedTitle
        });
    }

    function handleError(): void {
        somethingWentWrongBannerVisible = true;
    }
</script>
